if (!customElements.get('ht-product')) {
  class HtProduct extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-main]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.qty = this.querySelector('[data-qty]');
      this.variantInput = this.querySelector('[data-variant-id]');
      this.atc = this.querySelector('.ht-buy .ht-atc');
      this.sticky = this.querySelector('[data-sticky]');
      this.stickyBtn = this.querySelector('[data-sticky-btn]');

      this.#initGallery();
      this.#initQuantity();
      this.#initVariants();
      this.#initSticky();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #initGallery() {
      if (!this.main) return;
      const canHover = window.matchMedia('(hover: hover)').matches;
      const active = () => this.main.querySelector('.is-active img');

      if (canHover) {
        this.main.addEventListener('mouseenter', () => this.main.classList.add('is-zoom'));
        this.main.addEventListener('mouseleave', () => this.main.classList.remove('is-zoom'));
        this.main.addEventListener('mousemove', (event) => {
          const img = active();
          if (!img) return;
          const rect = this.main.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        });
      } else {
        this.main.addEventListener('click', () => this.main.classList.toggle('is-zoom'));
      }

      this.thumbs.forEach((thumb) =>
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.thumb);
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
          this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
          this.main.classList.remove('is-zoom');
        })
      );
    }

    #initQuantity() {
      if (!this.qty) return;
      this.querySelectorAll('[data-step]').forEach((button) =>
        button.addEventListener('click', () => {
          const next = (Number(this.qty.value) || 1) + Number(button.dataset.step);
          this.qty.value = Math.max(1, next);
        })
      );
    }

    #initVariants() {
      const data = this.querySelector('script[data-variants]');
      const optionsRoot = this.querySelector('[data-options]');
      if (!data || !optionsRoot) return;

      let variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      optionsRoot.addEventListener('change', () => {
        const chosen = [...optionsRoot.querySelectorAll('fieldset')].map(
          (fieldset) => fieldset.querySelector('input:checked')?.value
        );
        const match = variants.find((variant) => variant.options.every((value, i) => value === chosen[i]));
        if (match) this.#applyVariant(match);
      });
    }

    #applyVariant(variant) {
      if (this.variantInput) this.variantInput.value = variant.id;

      const price = this.querySelector('[data-price]');
      const compare = this.querySelector('[data-compare]');
      const save = this.querySelector('[data-save]');
      const stickyPrice = this.querySelector('[data-price-sticky]');
      if (price) price.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (compare) {
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
      }
      if (save) {
        save.textContent = `SAVE ${variant.pct}%`;
        save.hidden = !variant.onSale;
      }

      const stock = this.querySelector('[data-stock]');
      if (stock) {
        stock.innerHTML = variant.available
          ? '<span class="ht-stock ht-stock--in"><i class="ht-dot"></i>In Stock</span>'
          : '<span class="ht-stock ht-stock--out">Sold Out</span>';
      }
      if (this.atc) {
        this.atc.disabled = !variant.available;
        const label = this.atc.querySelector('[data-atc-label]');
        if (label) label.textContent = variant.available ? label.dataset.label : 'Sold out';
      }
      if (this.stickyBtn) this.stickyBtn.disabled = !variant.available;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    #initSticky() {
      if (!this.sticky || !this.atc) return;
      this.observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-show', show);
        this.sticky.setAttribute('aria-hidden', String(!show));
      });
      this.observer.observe(this.atc);

      // Reuse the main button so Minimog's product-form logic (cart drawer, errors, spinner) runs.
      this.stickyBtn?.addEventListener('click', () => this.atc.click());
    }
  }

  customElements.define('ht-product', HtProduct);
}
